import { RECEIVE_ACCOUNT, RECEIVE_EMPLOYEE_FORM, RECEIVE_EMPLOYEE_POLICY } from "./actions";

import type { Action } from "./createStore";
import type { SiteConfig } from "EmployerDashboard/store";

export const accountId = (state: string = "", action: Action): string => {
  if (action.type === RECEIVE_ACCOUNT) {
    return action.payload.id || state;
  }
  return state;
};
export const initialDataLoaded = (state: boolean = false, action: Action): boolean => {
  if (action.type === RECEIVE_EMPLOYEE_FORM) {
    return false;
  }
  if (action.type === RECEIVE_EMPLOYEE_POLICY) {
    return true;
  }
  return state;
};
export const siteConfig = (state: SiteConfig = {}, action: Action): SiteConfig => {
  if (action.type === RECEIVE_ACCOUNT) {
    return action.payload.siteConfig || state;
  }
  return state;
};
